/**
 * 数据字典初始化脚本
 * 用于在系统中预置常用的字典数据
 */

import { dictTypeService, dictDataService } from '../services/dictService';
import { DICT_TYPES, DEFAULT_DICT_DATA, DICT_TYPE_LABELS } from '../constants/dictTypes';

/**
 * 初始化数据字典
 * 创建字典类型和对应的字典数据
 */
export const initDictData = async () => {
  try {

    // 遍历所有字典类型
    for (const [dictTypeKey, dictType] of Object.entries(DICT_TYPES)) {
      const dictTypeLabel = DICT_TYPE_LABELS[dictType as keyof typeof DICT_TYPE_LABELS];
      const dictData = DEFAULT_DICT_DATA[dictType as keyof typeof DEFAULT_DICT_DATA];

      if (!dictData) {
        continue;
      }

      try {
        // 检查字典类型是否已存在
        const existingTypeResponse = await dictTypeService.getList({
          dictType,
          current: 1,
          size: 1
        });

        let dictTypeId: number;

        if (existingTypeResponse.code === 200 && existingTypeResponse.data.records.length > 0) {
          // 字典类型已存在，获取ID
          dictTypeId = existingTypeResponse.data.records[0].id;
        } else {
          // 创建字典类型
          const createTypeResponse = await dictTypeService.create({
            dictName: dictTypeLabel,
            dictType,
            status: 1,
            remark: `系统预置的${dictTypeLabel}字典`
          });

          if (createTypeResponse.code === 200) {
            dictTypeId = createTypeResponse.data.id;
          } else {
            console.error(`创建字典类型 ${dictTypeLabel} 失败:`, createTypeResponse.message);
            continue;
          }
        }

        // 检查并创建字典数据
        for (const dataItem of dictData) {
          try {
            // 检查字典数据是否已存在
            const existingDataResponse = await dictDataService.getList({
              dictType,
              dictValue: dataItem.dictValue,
              current: 1,
              size: 1
            });

            if (existingDataResponse.code === 200 && existingDataResponse.data.records.length > 0) {
              continue;
            }

            // 创建字典数据
            const createDataResponse = await dictDataService.create({
              ...dataItem,
              dictType,
              createBy: 'system',
              updateBy: 'system'
            });

            if (createDataResponse.code === 200) {
            } else {
              console.error(`创建字典数据 ${dataItem.dictLabel} 失败:`, createDataResponse.message);
            }
          } catch (error) {
            console.error(`处理字典数据 ${dataItem.dictLabel} 时出错:`, error);
          }
        }

      } catch (error) {
        console.error(`处理字典类型 ${dictTypeLabel} 时出错:`, error);
      }
    }

    return { success: true, message: '数据字典初始化完成' };

  } catch (error) {
    console.error('初始化数据字典失败:', error);
    return { success: false, message: '初始化数据字典失败', error };
  }
};

/**
 * 检查数据字典是否已初始化
 */
export const checkDictInitialized = async () => {
  try {
    const response = await dictTypeService.getList({
      current: 1,
      size: 1
    });

    return response.code === 200 && response.data.records.length > 0;
  } catch (error) {
    console.error('检查数据字典初始化状态失败:', error);
    return false;
  }
};

/**
 * 重置数据字典（删除所有预置数据）
 */
export const resetDictData = async () => {
  try {

    // 获取所有字典类型
    const typeResponse = await dictTypeService.getList({
      current: 1,
      size: 1000
    });

    if (typeResponse.code === 200) {
      const dictTypes = typeResponse.data.records;

      // 删除所有字典数据
      for (const dictType of dictTypes) {
        const dataResponse = await dictDataService.getList({
          dictType: dictType.dictType,
          current: 1,
          size: 1000
        });

        if (dataResponse.code === 200 && dataResponse.data.records.length > 0) {
          const dataIds = dataResponse.data.records.map((item: any) => item.id);
          await dictDataService.batchDelete(dataIds);
        }
      }

      // 删除所有字典类型
      const typeIds = dictTypes.map((item: any) => item.id);
      await dictTypeService.batchDelete(typeIds);
    }

    return { success: true, message: '数据字典重置完成' };

  } catch (error) {
    console.error('重置数据字典失败:', error);
    return { success: false, message: '重置数据字典失败', error };
  }
};

export default {
  initDictData,
  checkDictInitialized,
  resetDictData
};
